export const OAUTH_SUCCESS_RESPONSE = 'oauth_success'
